var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./cardNews.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-65fc7370\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./cardNews.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/cards/cardNews/cardNews.vue.html
// module id = ZGPC
// module chunks = 2